import { useCallback } from "react";
import { useApolloClient, useQuery } from "@apollo/client";
import { achievementsGQL, meGQL } from "@onmo/graphql/graphql";

import { PRODUCT_QUERY } from "../constants/achievement";
import { getWalletBalance } from "../constants/wallet";
import { setPreviousAchievements, setPreviousGzCoin } from "../models/storage";
import { useAppSelector } from "../components/hooks";
import { FEATURES } from "../types/theme";
import { useWalletConfig } from "./useWalletConfig";

/*
  Leaving for an external product destroys the app, so the reward screen has no
  "before" state left to compare the returning coins and achievements against.
*/
export const useExternalLaunchSnapshot = () => {
  const client = useApolloClient();
  const { data: dataMe } = useQuery(meGQL);
  const { walletConfig } = useWalletConfig();
  const { theme } = useAppSelector((state) => state.theme);
  const baseCoinType = walletConfig.primaryCurrency.base;
  const hideRewardPage =
    theme?.hideFeature?.includes(FEATURES.rewardPage) || false;

  const coinWallets = dataMe?.me?.coinWallets;

  return useCallback(async () => {
    // Without a coin baseline the reward screen never opens, so nothing to snapshot
    if (hideRewardPage || !coinWallets) return;

    setPreviousGzCoin(getWalletBalance(coinWallets, baseCoinType));

    try {
      const { data } = await client.query({
        query: achievementsGQL,
        variables: { input: { products: PRODUCT_QUERY } },
        fetchPolicy: "cache-first",
      });
      const items = data?.me?.achievements?.items;
      if (items?.length) setPreviousAchievements(items);
    } catch {
      // do nothing
    }
  }, [client, coinWallets, baseCoinType, hideRewardPage]);
};
